export function propsToInitialState(data, danhMucSanPhamList) {
  const dataInit = { ...data };
  dataInit.namDangKySuDung = data?.namDangKySuDung || null;
  dataInit.nhomSanPham =
    danhMucSanPhamList?.find(x => x?.id === data?.idNhomSanPham) || null;
  dataInit.hinhAnhDaiDiens = data?.hinhAnhDaiDien?.file_path
    ? [
        {
          bucket_name: data.hinhAnhDaiDien?.bucket_name || null,
          file_path: data.hinhAnhDaiDien?.file_path || null,
          file_oid: data.hinhAnhDaiDien?.file_oid || 0,
          file_name: data.hinhAnhDaiDien?.file_name || null,
          file_ext: data.hinhAnhDaiDien?.file_ext || null,
          file_size: data.hinhAnhDaiDien?.file_size || 0
        }
      ]
    : null;
  dataInit.tinhTrangHoatDong = data?.tinhTrangHoatDong === false ? false : true;
  return dataInit;
}

export function parseDataSave(value, profile) {
  const dataSave = { ...value };
  dataSave.namDangKySuDung = value?.namDangKySuDung || 0;
  dataSave.idNhomSanPham = value?.nhomSanPham?.id || 0;
  dataSave.idDoanhNghiep = profile?.idDoanhNghiep || 0;
  dataSave.hinhAnhDaiDien = value?.hinhAnhDaiDiens?.[0]?.file_path
    ? value?.hinhAnhDaiDiens?.[0]
    : null;
  dataSave.tinhTrangHoatDong = value?.tinhTrangHoatDong || false;
  return dataSave;
}
